module.exports = __webpack_public_path__ + "static/media/roma-1.8f72d6d7.jpeg";